import type { TrackingLabels } from "../tracking/TrackingLabels";
import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { SvelteFacet } from "./SvelteFacet";

const POPULAR_FACET_VALUES_GROUP_CLASS = "hc_facetValueGroup--ranges";

export class PopularFacetRanges {
  static readonly factory: HeurekaElementFactory<PopularFacetRanges, keyof HTMLElementTagNameMap> =
    HeurekaElementFactory.byClass(POPULAR_FACET_VALUES_GROUP_CLASS, PopularFacetRanges);

  /*               */
  constructor(readonly popularFacetValuesWrapper: HTMLElement) {}

  get facet() {
    return SvelteFacet.factory.closest(this.popularFacetValuesWrapper);
  }

  get sanPopularFacetValues(): TrackingLabels["san_PopularFacetValues"] | undefined {
    const facet = this.facet;
    if (facet && !facet.facet.hidden) {
      return facet.facet.name;
    }
  }
}
